import { render, staticRenderFns } from "./VqToggleBtn.vue?vue&type=template&id=b03d0806&scoped=true&lang=html&"
import script from "./VqToggleBtn.vue?vue&type=script&lang=js&"
export * from "./VqToggleBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b03d0806",
  null
  
)

export default component.exports